import React from 'react';
import { useLiveClock } from '@/hooks/useLiveClock';

function formatTime(date: Date): string {
  const h = String(date.getHours()).padStart(2, '0');
  const m = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');
  return `${h}:${m}:${s}`;
}

export const LiveClock: React.FC = () => {
  const now = useLiveClock();

  return (
    <span
      style={{
        fontFamily: 'var(--font-mono)',
        color: 'var(--text-secondary)',
        fontSize: '0.85rem',
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {formatTime(now)}
    </span>
  );
};
